export type Theme = 'light' | 'dark' | 'system'

const THEME_KEY = 'theme'

function resolveAndApply(theme: Theme) {
  const dark =
    theme === 'dark' ||
    (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches)
  document.documentElement.classList.toggle('dark', dark)
}

// Call once at startup before first render.
export function initTheme() {
  const saved = (localStorage.getItem(THEME_KEY) as Theme | null) ?? 'system'
  resolveAndApply(saved)
}

export function getTheme(): Theme {
  return (localStorage.getItem(THEME_KEY) as Theme | null) ?? 'system'
}

export function setTheme(theme: Theme) {
  localStorage.setItem(THEME_KEY, theme)
  resolveAndApply(theme)

  // When system mode is active, keep in sync with OS changes.
  // We re-run resolveAndApply lazily via the storage event on other tabs,
  // and here we listen for the media query change within this tab.
  const mql = window.matchMedia('(prefers-color-scheme: dark)')
  const syncSystem = () => { if (getTheme() === 'system') resolveAndApply('system') }
  mql.removeEventListener('change', syncSystem) // avoid stacking listeners
  if (theme === 'system') mql.addEventListener('change', syncSystem)
}
